var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOperations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4247 17.3986V19.2393C10.4247 19.9357 9.77354 20.5004 8.97018 20.5004C8.16682 20.5004 7.51562 19.9357 7.51562 19.2393V16.1367",
    stroke: "white",
    strokeWidth: 1.48274,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4088 4.5C14.7885 4.5 14.2523 4.91853 14.0006 5.52484L5.79893 9.06501C5.63623 8.7816 5.35777 8.59451 5.04152 8.59451H4.78743C4.28594 8.59451 3.87891 9.06501 3.87891 9.64499V14.6285C3.87891 15.2085 4.28533 15.679 4.78743 15.679H5.04152C5.35777 15.679 5.63623 15.4919 5.79893 15.2085L14.0006 18.748C14.2523 19.3543 14.7879 19.7728 15.4088 19.7728C16.271 19.7728 16.9699 18.9649 16.9699 17.9677V6.30508C16.9699 5.30795 16.271 4.5 15.4088 4.5Z",
    stroke: "white",
    strokeWidth: 1.48274,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6699 15.9215C19.2897 15.9215 20.6028 14.3896 20.6028 12.4998C20.6028 10.6101 19.2897 9.07812 17.6699 9.07812",
    stroke: "white",
    strokeWidth: 1.48274
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperations);
export default __webpack_public_path__ + "static/media/operations.c5b311036ae9c8fbf867fbdc1a10d8ba.svg";
export { ForwardRef as ReactComponent };